import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  UPDATE_QUANTITY,
} from '../actionConstants';

import {createReducer} from './reducerUtils';

const initialState = {
  items: [],
  totalQuantity: 0,
  totalPrice: 0,
};

const calculateTotals = items => {
  const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = items.reduce((sum, item) => sum + item.pricePerUnit * item.quantity, 0);
  return {totalQuantity, totalPrice};
};

const addToCart = (state, payload) => {
  const existingItem = state.items.find(item => item.productId === payload.productId && item.size === payload.size);
  let updatedItems;

  if (existingItem) {
    updatedItems = state.items.map(item =>
      item.productId === payload.productId && item.size === payload.size
        ? {
          ...item,
          quantity: item.quantity + payload.quantity,
        }
        : item,
    );
  } else {
    updatedItems = [
      ...state.items,
      {...payload},
    ];
  }

  const {totalQuantity, totalPrice} = calculateTotals(updatedItems);
  return {
    ...state,
    items: updatedItems,
    totalQuantity,
    totalPrice,
  };
};

const removeFromCart = (state, {productId, size}) => {
  const updatedItems = state.items.filter(item => {
    return !(item.productId === productId && item.size === size);
  });
  const {totalQuantity, totalPrice} = calculateTotals(updatedItems);
  return {...state, items: updatedItems, totalQuantity, totalPrice};
};

const updateQuantity = (state, {productId, size, quantity}) => {
  const updatedItems = state.items.map(item =>
    item.productId === productId && item.size === size ? {...item, quantity} : item,
  );
  const {totalQuantity, totalPrice} = calculateTotals(updatedItems);
  return {...state, items: updatedItems, totalQuantity, totalPrice};
};

export default createReducer(initialState, {
  [ADD_TO_CART]: addToCart,
  [REMOVE_FROM_CART]: removeFromCart,
  [UPDATE_QUANTITY]: updateQuantity,
});
